'use client';

import { c as _c } from "react/compiler-runtime";
import { type ErrorBoundaryProps, GlobalErrorBoundary } from '@/app/error-boundary';
export default function GlobalError(t0) {
  const $ = _c(3);
  const {
    error,
    reset
  } = t0;
  let t1;
  if ($[0] !== error || $[1] !== reset) {
    t1 = <GlobalErrorBoundary error={error} reset={reset} />;
    $[0] = error;
    $[1] = reset;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
}